import React from 'react';

const CoreTag = () => {
	return <span className="status teal-3 pair-type position-absolute right-3 bottom-3">Core Fabric</span>;
};

export default CoreTag;
